import PropTypes from 'prop-types';

import Colors from '../utils/colors';
import BackArrow from '../icons/BackArrow';
import IconButton from '../IconButton';

const BackButton = ({ size = 'base', ...rest }) => (
  <IconButton {...rest}>
    <BackArrow color={Colors.dark} size={size} />
  </IconButton>
);

BackButton.propTypes = {
  className: PropTypes.string,
  dataCy: PropTypes.string,
  dataTest: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['normal', 'small', 'extra_small']),
  circled: PropTypes.bool
};

export default BackButton;
